import { Link } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { LegalLayout } from "../components/LegalLayout";

export default function TermsAndConditions({ location }) {
  return (
    <LegalLayout location={location}>
      <Helmet>
        <title>Jeetar - Terms and Condition</title>
      </Helmet>

      <section className="mt-10 privacy-policy">
        <section className="mt-5 shadow-sm bg-white rounded-[10px] py-8 px-8">
          <article>
            <h4>JEETAR TERMS & CONDITIONS</h4>
          </article>
          <article>
            <h4>1. INTRODUCTION</h4>
            <p>
              These Terms and Conditions (these{" "}
              <strong className="text-k2Black">“Terms”</strong>) represent an
              agreement between you and Jeetar Technology Ltd (
              <strong className="text-k2Black">“Jeetar”</strong>) and contain
              the terms and conditions governing your use of and access to our
              website/mobile application and all affiliated websites/mobile
              applications owned and operated by us (collectively, the
              “Website”) and our products and services (together with the
              Website, the “Services”).
            </p>
            <p>
              “You” and “your” mean the person who uses or accesses the
              Services. “Jeetar”, “we”, “us” and “our” mean Jeetar and its
              successors, affiliates and assignees. As used in these Terms,
              “Jeetar Account” means the account you have with us for the
              Services.
            </p>
            <p>
              Your use of and access to the Services are always subject to these
              Terms and our Privacy Policy. Please read these Terms and our
              Privacy Policy carefully. By using or accessing the Services, you
              represent that you have read and understood these Term, and that
              you agree to be bound by these Terms. If you do not agree to all
              the terms and conditions of these Terms, do not use or access the
              Services in any manner.
            </p>
          </article>
          <article>
            <h4>2. OUR DETAILS</h4>
            <p>
              The Website, www.jeetar.com and the Jeetar Mobile Application are
              operated by Jeetar Technology Ltd. We are registered under the
              laws of the Federal republic of Nigeria under company number
              1828011 and have our head office at Plot 6, Block H, MKO Abiola
              Way, Ring Road, Ibadan, Oyo State.
            </p>
            <p>
              To contact us, please email [xxx] or call our customer service
              line on [xxx].
            </p>
          </article>
          <article>
            <h4>3. OTHER APPLICABLE TERMS</h4>
            <p>
              Further to your access or use of the Services, you may be subject
              to additional terms, rules, policies, and conditions that are
              posted on the Website, including, but not limited to, our Privacy
              Policy (see further under clause 15 (Your Personal Information)),
              our Cookie Policy, terms and conditions for our promotions,
              referral or rewards programs, which are hereby incorporated by
              reference into these Terms. In the event of a conflict between any
              Additional Terms and these Terms, these Terms will prevail.
            </p>
          </article>
          <article>
            <h4>4. OTHER APPLICABLE TERMS</h4>
            <p>
              We amend these Terms from time to time. Every time you wish to use
              our Website, please check these terms to ensure you understand the
              terms that apply at that time.
            </p>
          </article>
          <article>
            <h4>5. CHANGES TO OUR WEBSITE OR MOBILE APPLICATION</h4>
            <p>
              We may update and change our Website or Mobile Application from
              time to time to reflect changes to our Services, our users' needs
              and our business priorities.
            </p>
          </article>
          <article>
            <h4>6. SUSPENSION OR WITHDRAWAL OF OUR WEBSITE</h4>
            <p>Our Website is made available free of charge.</p>
            <p>
              We do not guarantee that our Website, or any content on it, will
              always be available or be uninterrupted. We may suspend or
              withdraw or restrict the availability of all or any part of our
              Website for business and operational reasons. We will try to give
              you reasonable notice of any suspension or withdrawal.
            </p>
          </article>
          <article>
            <h4>7. ASSIGNMENT AND TRANSFERS</h4>
            <p>
              We may transfer our rights and obligations under these Terms to
              another. We will notify you in writing if this happens and we will
              ensure that the transfer will not affect your rights under these
              Terms.
            </p>
            <p>
              You may not transfer, assign, or delegate your rights or
              obligations under these Terms or your Jeetar Account in any way
              (by operation of law or otherwise) without our prior written
              consent.
            </p>
          </article>
          <article>
            <h4>8. TARGETED USERS</h4>
            <p>
              Our site is directed at people residing in the Federal Republic of
              Nigeria. We do not represent that content available on or through
              our Website is appropriate for use or available in other
              locations.
            </p>
          </article>
          <article>
            <h4>9. YOUR JEETAR ACCOUNT</h4>
            <h6>Requirements to use the Services</h6>

            <p>To use the Services, you must</p>
            <ul>
              <li>register and open an account with us on the Website;</li>

              <li>
                provide all information requested by us, such as your name,
                email address, mobile number, address and such other information
                as we may request from time to time (collectively, "User
                Information").
              </li>
            </ul>
            <p>
              You represent and warrant that all User Information you provide us
              from time to time is truthful, accurate, current, and complete,
              and you agree not to misrepresent your identity or your User
              Information. You agree to promptly notify us of changes to your
              User Information by updating your Jeetar Account.
            </p>

            <h6>Verification of Information</h6>

            <p>
              To enable us to provide the Services to you, you hereby authorize
              us to, directly or through a third party, obtain, verify, and
              record information and documentation that helps us to provide the
              Services. We reserve the right to perform due diligence checks on
              Jeetar users.
            </p>
            <p>
              The information you provide us is subject to our Privacy Policy
              [insert link].
            </p>

            <h6>Account Details</h6>

            <p>
              You must treat the details of your Jeetar Account as confidential.
              This includes details such as a username, identification code,
              password or any other piece of information provided as part of our
              security procedures. You must not disclose such details to any
              third party.
            </p>
            <p>
              We have the right to disable any username, identification code or
              password, whether chosen by you or allocated by us, at any time,
              if in our reasonable opinion you have failed to comply with any of
              the provisions of these Terms.
            </p>
            <p>
              If you know or suspect that anyone other than you knows your
              username, identification code or password, or has otherwise gained
              access to your Jeetar Account, you must promptly notify us at
              [insert email]. In order to take any action, you will need to
              provide certain User Information so we can verify your identity.
            </p>

            <h6>Closing your Jeetar Account</h6>

            <p>
              You may stop using the Services, close your Jeetar Account, and
              cancel these Terms at any time by contacting us at [insert email]
              and providing sufficient information for us to verify your
              identity. You may also close your Jeetar Account via the Website
              or Mobile Application.
            </p>
            <p>
              Notwithstanding the foregoing, if there are any pending
              transactions relating to your Jeetar Account when we receive your
              termination notice, we will close your Jeetar Account promptly
              after such transactions are completed. Your termination of these
              Terms will not affect any of our rights or your obligations
              arising under these Terms prior to termination.
            </p>
            <p>This clause 9.4 shall survive termination of these Terms.</p>
          </article>

          <article>
            <h4>10. OUR SERVICES</h4>
            {/* <h6>Requirements to use the Services</h6> */}

            <p>
              The purpose of the Services is to leverage technology to grant you
              easy access to products and services. The Services include access
              to household products, local stores, local malls, local
              pharmacies, local restaurants, delivery services, car hire
              services, and other related services.
            </p>
            <p>
              Some features may be limited depending on your location and based
              on the information you have provided.
            </p>
            <p>
              Jeetar reserves the right to make any changes to the Services,
              including those which are necessary to comply with any applicable
              law or regulations. Jeetar shall make every effort to deliver
              products and services listed on the Website and Mobile Application
              within the estimated timescales, however, delays are occasionally
              unavoidable due to unforeseen circumstances. Jeetar shall not be
              liable for any delay or failure to deliver products within the
              estimated timescales.
            </p>
            <p>
              You agree not to hold Jeetar liable for any delay or failure to
              deliver products or otherwise perform any obligation as specified
              in these Terms if the same is wholly or partly caused whether
              directly or indirectly by circumstances beyond our reasonable
              control.
            </p>

            <h4>
              Courier Services, Car Hire Service and other Logistic Services
            </h4>
            <h6>Car Hire Services</h6>

            <p>
              Jeetar offers a platform that enables users to arrange and
              schedule transportation with independent third-party drivers,
              including third-party transportation providers. Transport services
              are provided by third-party drivers on an independent basis under
              a service contract with use, as a Jeeter service.
            </p>
            <p>
              A user enters into a contract with a driver for the provision of
              transport services via the Website or Mobile Application, with
              payment made to the driver either in cash or via any of other
              payment modes made available on the Website or the Mobile
              Application provided by drivers on an independent basis.
            </p>

            <h6>Courier Services</h6>
            <p>
              Jeetar provides package delivery and logistics services to its
              users. Jeetar shall endeavour to collect and deliver packages with
              minimal hassle to our users. Jeetar will only attempt to collect
              and deliver a package during normal working hours. Users shall
              ensure that a recipient is available at the delivery point to
              accept the package and provide delivery receipt. If Jeeter is
              unable to contact the recipient and cannot obtain a delivery
              receipt, you agree that Jeetar shall be authorised to attempt to:
            </p>

            <ul>
              <li>
                deliver the package and/or obtain the delivery receipt from an
                alternative address close to the delivery point;
              </li>

              <li>
                deliver the package to a safe location at the delivery point;
              </li>
            </ul>

            <p>
              and if successful, Jeetar shall leave details of the address or
              safe location where the package was delivered at the delivery
              point.
            </p>
            <p>
              If Jeetar is unable to deliver to the delivery point, a nearby
              address or safe location, Jeetar shall return the package to a
              designated location and leave a message or request for the
              delivery recipient to contact us to make alternative delivery
              arrangement to the delivery point. If the delivery recipient does
              not contact us to arrange alternative delivery within 7 days, the
              package shall be returned to the collection point at your cost.
            </p>
            <p>
              In addition, save for a simple hand-off of the package, Jeetar
              shall be under no obligation to provide any equipment or labour
              for loading or unloading a package. Where such equipment is not
              available and a rider agrees to load or unload the package without
              the equipment, Jeetar shall be under no liability or obligation to
              you for any damage caused to the package. In addition, you agree
              to indemnify and hold us harmless against any claim or demand from
              any third party arising out of the loading or unloading of a
              package in these circumstances. You are encouraged to properly
              pack your product to prevent damage to the product as much as is
              possible.
            </p>
            <p>
              Jeeter reserves the right to refuse the collection and delivery of
              any package that is reasonably, believed to be unsafe, hazardous,
              harmful or is in violation with applicable law and regulation.
            </p>
            <p>
              You agree that you shall provide accurate and complete information
              to enable us collect and deliver packages, including all necessary
              information regarding the package to be delivered. You shall
              co-operate with our riders and provide access to your location as
              reasonably required in the provision of the Services. You shall be
              responsible for ensuring that the premises are free of any
              materials that pose a health and safety risk to the rider. You
              agree that Jeetar shall not be required and that you shall not
              cause our riders to carry any package against our company policy
              or any illegal or unlawful package that violates the laws of the
              Federal Republic of Nigeria, including livestock, gasses,
              pyrotechnics, arms, ammunitions, corrosive, prohibited drugs,
              toxic, flammable, explosive, oxidising or radioactive materials.
              You agree that should you do this, you will indemnify Jeetar
              against any losses and/or damage that we may suffer as a
              consequence.
            </p>
            <p>
              In the event that a package is not delivered to the delivery point
              or is not delivered in good condition, you are to report any
              damaged/missing/lost items by contacting us at [insert email] or
              on [insert number], and we shall use our best endeavours to
              resolve the matter and connect you to the right authority to
              investigate damage to or loss of your package.
            </p>
            <p>
              We do not make any representations, warranties or guarantees that
              the Services are appropriate for you.
            </p>

            <h6>Access to Household Products</h6>
            <p>
              Jeetar provides certain goods for sale to its users (JeetMart).
              The sale of products under JeetMart is between you and Jeetar.
              Both parties agree that products listed under JeetMart does not
              constitute an offer to sell but rather an invitation to treat.
              Parties agree that users make an offer to buy by selecting items
              they intend to purchase and complete the checkout process,
              including paying for the products.
            </p>
            <p>
              Both parties agree that the offer is accepted by Jeetar when we
              dispatch the product to you and inform you by email or phone of
              the dispatch of your products.
            </p>
            <p>
              Where an order cannot be processed for any reason, we receive the
              right to refuse or cancel the order at any given time (whether the
              order has been confirmed or not) and we will process a full refund
              where you have already paid for the order.
            </p>

            <h6>
              Access to Local Shops, Malls, Pharmacies, Restaurants and Hotels
            </h6>
            <p>
              Jeeter partners with local shops, supermarkets, malls, pharmacies,
              restaurants, hotels and other service merchants (“Partner Stores”)
              for the provision of relevant products and services to you. By
              placing an order through our Website or Mobile Application, you
              enter into an agreement with Jeetar for the processing of that
              order and forwarding to the participating Partner Store. Partner
              Stores are responsible for the preparation and quality of your
              order.
            </p>
            <h6>Dispute with Partner Stores</h6>
            <p>
              If you are unsatisfied with any products or services that you have
              purchased using our Services, you should contact the Partner Store
              with your complaint. If a dispute arises between you and a Partner
              Store, you release us (and our agents and employees) from any and
              all claims, demands, and damages (actual and consequential) in any
              way connected with the dispute and the transaction. However, if
              you are unable to resolve the matter with the Partner Store, you
              may file a complaint against the Partner Store by contacting us
              using the details provided in clause 2{" "}
              <strong className="text-k2Black">(Our Details)</strong>.
            </p>
            <h6>Promotional Activity</h6>
            <p>
              We may issue vouchers or gift cards pursuant to a promotional
              activity. Such vouchers and gift cards shall be subject to the
              terms and conditions of the promotion. Vouchers or gift cards may
              be used within the period specified in the terms and conditions of
              the promotion.
            </p>
            <p>
              We reserve the right to cancel any promotions without cause,
              including if you close your Jeetar Account.
            </p>
            <h6>Restrictions on the Services</h6>
            <p>
              The Services may be used for both personal and commercial use.
              Your use of the Services must comply with all applicable law.
            </p>

            <h3>Commercial Users</h3>

            <p>
              For commercial users, we exclude all implied conditions,
              warranties, representations or other terms that may apply to the
              Website/Mobile Application or any content on it, save for those
              expressly provided for in these Terms. We will not be liable to
              you for any loss or damage, whether in contract, tort (including
              negligence), breach of statutory duty or otherwise arising under
              or in connection with your use of, or inability to use our
              Website/mobile application; or use of or in reliance on any
              content displayed on our Website/Mobile Application. We will not
              be liable for loss of profits, sales, business or revenue,
              business interruption, loss of anticipated savings, loss of
              business opportunity, goodwill or reputation, or any indirect or
              consequential loss or damage.
            </p>

            <h3>Personal Users</h3>

            <p>
              We are not responsible if you use the Services in any manner that
              violates applicable law. We have no liability to you for any loss
              of profit, loss of business, business interruption, or loss of
              business opportunity.
            </p>
            <h3>General Provisions</h3>

            <p>
              You agree not to authorize any other person or entity to use your
              Jeetar Acount login details (username and password) or mobile
              device to access the Services. You are solely responsible for the
              maintenance, confidentiality, and security of your username,
              password, and other User Information. Except as otherwise required
              by applicable law, you are responsible for all transactions and
              other activities authorized or performed using your username and
              password or mobile device, whether authorized or unauthorized by
              you.
            </p>
            <p>
              Except as otherwise expressly stated in these Terms or required by
              applicable law, we are not responsible for any losses arising out
              of the loss or theft of your User Information or your mobile
              device or from unauthorized or fraudulent transactions associated
              with your bank account, your credit/debit card or your Jeetar
              Account. If you suspect or become aware of any unauthorized
              activity or access to your username, password, or mobile device,
              you must contact us immediately as provided in clause 2{" "}
              <strong className="text-k2Black">(Our Details)</strong>.
            </p>
            <p>
              We offer the Services and the features, information, materials,
              and content provided and depicted through the Services
              (collectively, "Content") solely for your use for the purposes
              described therein and in these Terms. All other uses are
              prohibited. You may not restrict or inhibit any other person from
              using or enjoying the Services or Content.
            </p>

            <h6>Disclaimers</h6>
            <p>
              To the fullest extent permitted by applicable law and except as
              otherwise expressly provided in these Terms, you expressly
              understand and agree that your use of the Services and all Content
              (including that of third parties) included in or accessible from
              the Services is at your sole risk.
            </p>
            <p>
              The Services are provided ‘as is’ and ‘as available’ without any
              warranty of any kind. To the maximum extent permitted by law, we
              and our third-party service providers expressly disclaim any and
              all conditions, representations and warranties of any kind as to
              the Services and all information, products and other content
              (including that of their parties) included or accessible from the
              Services, whether express, implied, statutory or otherwise,
              including but not limited to, any warranty of merchantability,
              fitness for a particular purpose and non-infringement.
            </p>
          </article>
          <article>
            <h4>11. ELECTRONIC SIGNATURES AND COMMUNICATIONS</h4>
            <h6>Consent</h6>
            <p>
              To the extent permitted by applicable law, you consent to use
              electronic signatures and to electronically receive all records,
              notices, statements, communications and other items for all
              Services provided to you under these Terms and in connection with
              your relationship with is (collectively, “Communications”) that we
              may otherwise be required to send or provide to you in paper form.
            </p>
            <p>
              To use the Services, you must provide and verify your mobile
              device number or other text message address to us, and you must
              expressly consent to receive text messages relating to the
              Services at that number or address. Third-party data and message
              fees may apply. To verify your mobile device number or text
              message address, we may send you a code via text message to the
              mobile device number or text message address you provide, and you
              must enter that code as instructed by us.
            </p>
            <p>
              If you change your mobile device number or text message address,
              you must promptly provide and verify your new mobile device number
              or text message address. In addition, if you provide your email
              address to us, we may send you important notices via email about
              the Services.
            </p>
            <p>
              You may print and save and/or electronically store a copy of all
              Communications that we send to you.
            </p>

            <p>
              By accepting and agreeing to these Terms electronically, you
              represent that:
            </p>

            <ul>
              <li>
                you have read and understood this consent to use electronic
                signatures and to receive Communications electronically;
              </li>

              <li>
                you satisfy the minimum hardware and software requirements
                specified above; and
              </li>
              <li>
                Your consent will remain in effect until you withdraw your
                consent as specified below.
              </li>
            </ul>

            <p>
              You may withdraw your consent to receive further Communications
              electronically at any time by contacting us at the details
              provided in clause 2{" "}
              <strong className="text-k2Black">(Our Details)</strong>. If you
              withdraw your consent to receive Communications electronically, we
              will close your Jeetar Account as set forth in these Terms, and
              you will no longer be able to use your Jeetar Account or the
              Services, except as expressly provided in these Terms.
            </p>

            <p>
              Any withdrawal of your consent to receive Communications
              electronically will be effective only after we have a reasonable
              period to process your withdrawal. Please note that withdrawal of
              your consent to receive Communications electronically will not
              apply to Communications electronically provided by us to you
              before the withdrawal of your consent becomes effective.
            </p>
            <p>
              Any contact details provided by you shall be subject to our
              Privacy Policy.
            </p>

            <h6>Changes to our Communications Policy</h6>
            <p>
              We reserve the right, in our sole discretion, to communicate with
              you in paper form. In addition, we reserve the right, in our sole
              discretion, to discontinue the provision of electronic
              Communications or to terminate or change the terms and conditions
              on which we provide electronic Communications. Except as otherwise
              required by applicable law, we will notify you of any such
              termination or change by updating these Terms on the Website or
              delivering notice of such termination or change electronically.
            </p>
          </article>

          <article>
            <h4>12. CONTENT ON OUR WEBSITE</h4>
            <p>
              We are the owner or the licensee of all intellectual property
              rights on our Website, and in the Content published on it. Those
              works are protected by copyright laws and treaties around the
              world. All such rights are reserved.
            </p>

            <p>
              Except as expressly provided by these Terms or with our prior
              written consent, you may not use, modify, disassemble, decompile,
              reverse engineer, reproduce, distribute, rent, sell, license,
              publish, display, download, transmit, or otherwise exploit any
              Content in any form by any means. Particularly, without limiting
              the foregoing, you agree not to or to allow a third party to:
            </p>

            <ul>
              <li>
                take any action that we determine imposes or may impose an
                unreasonable or a disproportionately large load on the Services
                or our infrastructure
              </li>

              <li>
                utilize any device, software, or routine that will interfere or
                attempt to interfere with the functionality of the Services
              </li>
              <li>
                reverse engineer, decompile, disassemble, or otherwise seek to
                obtain the source code of the Services or Content
              </li>
              <li>
                modify the Services or Content or create any derivative product
                from the Services or Content
              </li>
              <li>
                use the Services or Content in any way that is illegal, harmful,
                fraudulent, deceptive, threatening, harassing, defamatory,
                obscene, or otherwise objectionable
              </li>
              <li>
                attempt, in any manner, to obtain the username, password,
                account, or other security information from any other user of
                the Services
              </li>
              <li>
                violate the security of any computer network or crack any
                passwords or security encryption codes
              </li>
            </ul>

            <p>
              You may print off one copy, and may download extracts, of any
              page(s) from our Website for your personal use.
            </p>
            <p>
              You must not modify the paper or digital copies of any Content you
              have printed off or downloaded in any way, and you must not use
              any illustrations, photographs, video or audio sequences or any
              graphics separately from any accompanying text.
            </p>
            <p>
              Our status (and that of any identified contributors) as the
              authors of Content on our Website must always be acknowledged
              (except where the content is user-generated).
            </p>
            <p>
              You must not use any part of the Content on our site for
              commercial purposes without obtaining a licence to do so from us
              or our licensors.
            </p>
            <p>
              If you print off, copy, download, share or repost any part of our
              Website in breach of these Terms, your right to use our site will
              cease immediately and you must, at our option, return or destroy
              any copies of the materials you have made.
            </p>

            <h6>Our Trademark</h6>
            <p>
              “Jeetar" is a registered trademarks of Jeetar Technology Ltd. You
              are not permitted to use it without our approval, unless they are
              part of material you are using as permitted under this Clause 12{" "}
              <strong className="text-k2Black">(Content on our Website)</strong>
              .
            </p>

            <h6>No Text or Data Mining, or Web Scraping</h6>
            <p>
              You shall not conduct, facilitate, authorise or permit any text or
              data mining or web scraping in relation to our Website or any
              services provided via, or in relation to, our Website. This
              includes using (or permitting, authorising or attempting the use
              of):
            </p>
            <p>
              Any "robot", "bot", "spider", "scraper" or other automated device,
              program, tool, algorithm, code, process or methodology to access,
              obtain, copy, monitor or republish any portion of the site or any
              data, content, information or services accessed via the same.
            </p>
            <p>
              Any automated analytical technique aimed at analysing text and
              data in digital form to generate information which includes but is
              not limited to patterns, trends and correlations.
            </p>
            <p>
              This clause shall not apply insofar as (but only to the extent
              that) we are unable to exclude or limit text or data mining or web
              scraping activity by contract under the laws which are applicable
              to us.
            </p>

            <h6>Third Party Links</h6>
            <p>
              Where our Website/Mobile Application contains links to other sites
              and resources provided by third parties, these links are provided
              for your information only. Such links should not be interpreted as
              approval by us of those linked websites or information you may
              obtain from them.
            </p>
            <p>
              We have no control over the content of those sites or resources
              and are not responsible for their availability or content.
            </p>
            <p>
              We assume no liability whatsoever for any such third-party
              websites or services or any content, features, products, or
              practices of such third-party websites or services. Your access
              and use of such third-party websites and services are subject to
              applicable third-party terms and conditions and privacy policies.
              We encourage you to read the terms and conditions and privacy
              policy of each third-party website or service that you visit or
              utilize.
            </p>

            <h6>Limitation of Liability</h6>
            <p>
              We do not exclude or limit in any way our liability to you where
              it would be unlawful to do so. This includes liability for death
              or personal injury caused by our negligence or the negligence of
              our employees, agents or subcontractors and for fraud or
              fraudulent misrepresentation.
            </p>
            <p>
              Any material downloaded or otherwise obtained through the Services
              is done at your own discretion and risk, and you are solely
              responsible for any damage to your computer system or mobile phone
              or for any loss of data that results from the download of any such
              material.
            </p>
            <p>
              You are advised to follow our installation instructions or to have
              in place the minimum system requirements advised by us.
            </p>
            <p>
              To the fullest extent permitted by applicable law, you agree that
              Jeetar, its affiliates, and its and their respective employees,
              officers, directors, agents and their-party service providers will
              not be liable to you or any third-party for:
            </p>

            <ul>
              <li>
                the performance of the Services or the inability to use the
                Services
              </li>

              <li>
                any indirect, incidental, special, consequential, punitive or
                exemplary damages, whether based in contract, tort or otherwise,
                including but not limited to, damages for loss of profits,
                goodwill, use, data or other intangible losses
              </li>
              <li>
                any amount, in aggregate, in excess of the cost of the Service
                procured by You; and
              </li>
              <li>any event beyond our reasonable control</li>
            </ul>

            <h6>Warranty and Indemnity</h6>
            <p>
              We and our third-party service providers make no warranty that:
            </p>
            <ul>
              <li>the Services will meet your requirement</li>

              <li>
                the Services will be uninterrupted, timely, secure or error-free
              </li>
              <li>
                the results that may be obtained from the use of the services
                will be accurate or reliable
              </li>
              <li>
                the quality of any products, services, information or other
                material purchased or obtained by you through the Services will
                meet your expectations; or
              </li>
              <li>
                any errors in the Services will be corrected. No oral or written
                information or advice obtained by you from us or our third-party
                service providers through or from the services will create any
                warranty not expressly stated in these Terms.
              </li>
            </ul>

            <p>
              You agree to defend, indemnify, and hold harmless Jeetar, its
              affiliates, and its and their respective employees, officers,
              directors, agents, and third-party service providers from and
              against any and all claims, suits, liabilities, damages (actual
              and consequential), losses, fines, penalties, costs, and expenses
              (including reasonable attorneys’ fees) arising from or in any way
              related to any third-party claims relating to your use of the
              Services, violation of these Terms, applicable law or any
              third-party rights, or your fraud or wilful misconduct. Such
              indemnified parties reserve the right to assume the exclusive
              defence and control of any matter subject to indemnification by
              you and you will cooperate in asserting any available defences.
            </p>
          </article>

          <article>
            <h4>13. YOUR PERSONAL INFORMATION</h4>
            <p>
              We will only use your personal information as set out in our
              Privacy Policy [insert link]. You must keep your contact
              information current with us in order to ensure that we are able to
              provide Communications to you electronically. You must notify us
              of any change to your email address, mobile device number or other
              text message address by updating your profile on the Website.
            </p>
          </article>

          <article>
            <h4>14. VIRUSES</h4>
            <p>
              We do not guarantee that our Website will be secure or free from
              bugs or viruses.
            </p>
            <p>
              You are responsible for configuring your information technology,
              computer programmes and platform to access our Website. You should
              use your own virus protection software.
            </p>
            <p>
              You must not misuse our Website by knowingly introducing viruses,
              trojans, worms, logic bombs or other material that is malicious or
              technologically harmful. You must not attempt to gain unauthorised
              access to our Website, the server on which our Website is stored
              or any server, computer or database connected to our Website. You
              must not attack our site via a denial-of-service attack or a
              distributed denial-of service attack. By breaching this provision,
              you would commit a criminal offence under the Cybercrimes
              (Prohibition, Prevention, etc) Act 2015. We will report any such
              breach to the relevant law enforcement authorities and we will
              co-operate with those authorities by disclosing your identity to
              them. In the event of such a breach, your right to use our site
              will cease immediately.
            </p>
          </article>

          <article>
            <h4>15. LINKS TO OUR WEBSITE</h4>
            <p>
              You may link to our home page, provided you do so in a way that is
              fair and legal and does not damage our reputation or take
              advantage of it.
            </p>
            <p>
              You must not establish a link in such a way as to suggest any form
              of association, approval or endorsement on our part where none
              exists.
            </p>
            <p>
              We reserve the right to withdraw linking permission without
              notice.
            </p>
            <p>
              If you wish to link to or make any use of content on our Website
              other than that set out above, please contact us at the details
              set out in clause 2{" "}
              <strong className="text-k2Black">(Our Details)</strong>.
            </p>
          </article>

          <article>
            <h4>16. TAXES</h4>
            <p>
              You will be responsible for paying, withholding, filing, and
              reporting all taxes, duties, and other governmental assessments
              associated with your activity in connection with the Services,
              provided that we may, in our sole discretion, do any of the
              foregoing on your behalf or for ourselves. The failure of either
              you or us to exercise, in any way, any right herein will not be
              deemed a waiver of any further rights hereunder.
            </p>
          </article>

          <article>
            <h4>17. PARTIAL INVALIDITY</h4>
            <p>
              If any provision of these Terms is found to be unenforceable or
              invalid by any applicable law, judicial or other competent
              authority, that provision will be limited or eliminated, to the
              minimum extent necessary, so that these Terms will otherwise
              remain in full force and effect and enforceable.
            </p>
          </article>

          <article>
            <h4>18. GOVERNING LAW AND JURISDICTION</h4>
            <p>
              These Terms of use, their subject matter and their formation, are
              governed by the laws of the Federal Republic of Nigeria.
            </p>
            <p>
              You and we both agree that any disputes or claims arising from or
              in connection with the Services or these Terms shall be subject to
              settlement using our best endeavours.
            </p>
            <p>
              If no settlement is reached within 60 (sixty) days of a written
              notice of the dispute or claim by the aggrieved party, the dispute
              shall be referred to a court of competent jurisdiction in Lagos,
              Nigeria.
            </p>
            <p>
              Each party shall bear its own costs and expenses in relation to
              the dispute resolution, save for a judgment or orders on costs,
              which shall be borne by the party against whom the judgment or
              order is made.
            </p>
            <p>
              As used in this clause, "we" and "us" mean Jeetar and its
              subsidiaries, affiliates, predecessors, successors, and assigns
              and all of its and their respective employees, officers,
              directors, agents, and representatives. In addition, "we" and "us"
              include any third party providing any product, service, or benefit
              in connection with the Services or these Terms (as well as any
              related or prior agreement that you may have had with us) if such
              third party is named as a co-party with us in any controversy,
              dispute, demand, claim, or cause of action subject to this
              Section.
            </p>
            <p>
              This Clause 18 shall survive the termination or expiration of
              these Terms.
            </p>
          </article>
        </section>
      </section>
    </LegalLayout>
  );
}
